/**
 * Copyright (c) samjay.dev.
 *
 * Notes:
 * This source code is the private property of samjay.dev.
 * You cannot modify, share or copy these source codes without any formal authorization,
 * otherwise samjay.dev reserves the right to pursue any legal action.
 *
 * Developer: Sam Tsang (info@samjay.dev)
 */

import { StarEmphasis24Regular, Comment24Regular, ShareIos24Regular } from '@fluentui/react-icons';
import moment from 'moment';
import React from 'react';
import { useParams } from 'react-router-dom';
import AppStyle from 'scss/main/App.module.scss';
import { useGetBlogQuery } from 'services/blog.sevices';
import { decodeHtml } from 'utils';

const Comment: React.FC<{
  cid: number;
  uid: number;
  display_name: string;
  avatar: string;
  comment: string;
  created_time: number;
  updated_time: number;
}> = ({
  cid, uid, display_name, avatar, comment, created_time, updated_time
}) => {

  return (
    <div>
      <div>
        {avatar ? <div style={{ backgroundImage: `url('${avatar}')`}} /> : <div><div>{display_name.charAt(0)}</div></div>}
        <div>
          <div>{display_name}</div>
          <div>{moment((created_time ?? 0) * 1000).fromNow()}</div>
        </div>
      </div>
      <div dangerouslySetInnerHTML={{ __html: decodeHtml(comment) }} />
    </div>
  );
}

export default Comment;